module.exports = __webpack_public_path__ + "img/covers-07.20939f5b.png";